export const getDaysOfWeek = (numbers: number[]): string[] => {
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  return numbers.map((number) => days[number]);
};
